import { FC } from 'react'
import { User } from 'graphql/types'
import { toCurrency } from 'lib/number'
import { getFirstName } from 'lib/user'
import { getAveragePrice } from 'lib/search'
import { IconRealEstate } from 'icons'
import Typography from 'components/Typography'
import Button from 'components/Button'
import styles from './EmptyRecommendations.module.scss'
import * as events from 'pages/recomendacoes/events'

type TProps = {
  openQEVModal: () => void
  userProfile?: User | null
}

const EmptyRecommendations: FC<TProps> = ({ openQEVModal, userProfile }) => {
  const firstName = getFirstName(userProfile?.name || '')
  const neighborhoods =
    userProfile?.searchPreferences?.neighborhoods?.join(', ')
  const city = userProfile?.searchPreferences?.city
  const citySlug = userProfile?.searchPreferences?.citySlug as string
  const stateSlug = userProfile?.searchPreferences?.stateSlug as string
  const budget = userProfile?.searchPreferences?.maxValue

  const { minimum, maximum } = getAveragePrice(budget || 0)

  const listingUrl = `/imoveis/${stateSlug}/${citySlug}?de-${minimum}-ate-${maximum}`

  return (
    <div className={styles.ecRecommendationsPageEmptyRecommendations}>
      <div className={styles.ecRecommendationsPageEmptyRecommendationsWrapper}>
        <div
          className={
            styles.ecRecommendationsPageEmptyRecommendationsIconWrapper
          }
        >
          <IconRealEstate
            color="grey900"
            title="Ícone: Imóvel"
            width={32}
            height={32}
          />
        </div>
        <Typography
          as="h1"
          variant="Title"
          bold
          className={styles.ecRecommendationsPageEmptyRecommendationsTitle}
        >
          {firstName}, ainda não temos recomendações para você
        </Typography>
        <Typography
          className={styles.ecRecommendationsPageEmptyRecommendationsText}
        >
          Estamos buscando imóveis com as seguintes características:
        </Typography>
        <div className={styles.ecRecommendationsPageEmptyRecommendationsBox}>
          <dl
            className={styles.ecRecommendationsPageEmptyRecommendationsBoxList}
          >
            <dt
              className={
                styles.ecRecommendationsPageEmptyRecommendationsBoxListItem
              }
            >
              <Typography variant="ParagraphBig" bold>
                Bairros em {city}
              </Typography>
            </dt>
            <dd
              className={
                styles.ecRecommendationsPageEmptyRecommendationsBoxListValue
              }
            >
              {neighborhoods}
            </dd>

            <dt
              className={
                styles.ecRecommendationsPageEmptyRecommendationsBoxListItem
              }
            >
              <Typography variant="ParagraphBig" bold>
                Orçamento
              </Typography>
            </dt>
            <dd
              className={
                styles.ecRecommendationsPageEmptyRecommendationsBoxListValue
              }
            >
              {toCurrency(budget)}
            </dd>
          </dl>
        </div>
        <Button
          theme="pink"
          size="big"
          className={styles.ecRecommendationsPageEmptyRecommendationsButton}
          onClick={() => {
            openQEVModal()
            events.recommendationsQEVUpdateButtonClickEvent()
          }}
        >
          Refinar recomendações
        </Button>

        <Button
          size="big"
          className={styles.ecRecommendationsPageEmptyRecommendationsButton}
          element="a"
          href={listingUrl}
          onClick={() => events.recommendationsSearchButtonClickEvent()}
        >
          Buscar imóveis
        </Button>
      </div>
    </div>
  )
}

export default EmptyRecommendations
